import { useEffect } from 'react';

const useHabitat = (): Function => {
  useEffect(() => {
    if (window.updateHabitat) {
      window.updateHabitat();
    }
  }, []);

  return window.updateHabitat as Function;
};

export default useHabitat;
